var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AttrIndexService } from './attr-index.service';
import { NagService } from './nag.service';
import { UserService } from './user.service';
import { CommonFunctionService } from './common-function.service';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
import * as i2 from "./common-function.service";
import * as i3 from "./nag.service";
import * as i4 from "./user.service";
var AgencyInfoService = /** @class */ (function () {
    function AgencyInfoService(attrIndexService, commonService, nagService, userService) {
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.nagService = nagService;
        this.userService = userService;
        this.givBdryCateList = [{
                prop: 'COUNTY',
                name: 'COUNTY'
            }, {
                prop: 'REGION',
                name: 'REGION'
            }];
    }
    // getIsLayerTypeFromNguidPattern(patterNum: number) {
    // 	return patterNum === 2 ? true : false
    // }
    AgencyInfoService.prototype.getCounties = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stateCode, countiesRsp, countyList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stateCode = this.userService.customerInfo.givState;
                        return [4 /*yield*/, this.nagService.getNagNamesStandard(2, stateCode, null, { pageNumber: 0 })];
                    case 1:
                        countiesRsp = _a.sent();
                        if (countiesRsp.data) {
                            countyList = countiesRsp.data.map(function (i) {
                                return {
                                    name: i[_this.attrIndexService.stnNameCol],
                                    centroidStr: i[_this.attrIndexService.centroidCol],
                                    stnId: i[_this.attrIndexService.stnIdCol]
                                };
                            });
                            return [2 /*return*/, countyList];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AgencyInfoService.prototype.computeNguid = function (cateCode, globalId, nguidPattern) {
        nguidPattern = nguidPattern || this.userService.customerInfo.nguidPattern;
        var part1 = 'urn:emergency:uri:';
        var part2 = cateCode + ':';
        var part3 = (globalId || this.commonService.getRandomId()) + ':';
        var part4 = this.userService.customerInfo.discrepancyId;
        var nguid = nguidPattern.layerType ? part1 + part2 + part3 + part4 : part1 + part3 + part4;
        return nguid;
    };
    AgencyInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AgencyInfoService_Factory() { return new AgencyInfoService(i0.ɵɵinject(i1.AttrIndexService), i0.ɵɵinject(i2.CommonFunctionService), i0.ɵɵinject(i3.NagService), i0.ɵɵinject(i4.UserService)); }, token: AgencyInfoService, providedIn: "root" });
    return AgencyInfoService;
}());
export { AgencyInfoService };
